<template>
	<div class="newpage">
		<div class="printTest-box">
			<div id="printTest">
				<div style="display: flex;flex-direction: column;align-items: center;">
				    <div >
						<loading class="loading_style" :tip="tip" v-if="!th_printdata.length"></loading>
						<div ref="menuItem" v-else>
							<div    :style="sliderStyle"     v-for="(item,index) in th_printdata" :key="index">
								<div class="okngjkg" style="padding: 10px 15px;">
										<div class="giglnCopy">
											<div style="font-size:14px;width:175px">
												<div style="margin-bottom:5px">{{item.logistics}}</div>
												<div>Order Id</div>
												<div>{{item.orderId}}</div>
											</div>
											<div style="width:160px;height:80px;overflow:hidden;text-align:center">
                                                <div><img style="width:100%" :src="item.barcode" /></div>
                                                <div style="font-size:10px">{{item.orderId}}</div>
                                            </div>
										</div>
										<div style="">
											
										</div>

                                        <div class="omtbk" style="border-bottom: 1px dashed #000;">
                                            <div class="frome">From</div>
                                            <div class="nemgd">{{item.storeAddress.name}}</div>
                                            <div class="phone" style="font-size:14px;padding-top: 5px">{{item.storeAddress.phone}}</div>
                                            <div class="addressWrapper" style="font-size:14px;height: 103px;">{{item.storeAddress.address}}</div>
                                            <div style="font-size:14px;">{{item.storeAddress.city}}</div>
                                        </div>

                                        <div class="omtbk">
                                            <div class="frome">To</div>
                                            <div class="nemgd">{{item.address.name}}</div>
                                            <div class="phone" style="font-size:14px;padding-top: 5px">{{item.address.phone}}</div>
                                            <div class="addressWrapper" style="font-size:14px;height: 103px;">{{item.address.city}}{{item.address.state}}{{item.address.fullAddress}}</div>
                                            <div style="font-size:14px;">{{item.address.zipCode}}</div>
                                        </div>
										<div class="gigln">
											<div style="width:170px">
												<img style="width:100%" src="@assets/img/pic/id-01.png" />
											</div>
											<div style="font-size:10px;padding:0 10px 0 15px;width:175px">
												Thank you for shopping width Shopee.Please click 'Order Received' and rate this product!
											</div>
										</div>
                                </div>
								
								
							</div>
							
						</div>
					</div>
				</div>
			</div>
			
			 
			
			
			
		</div>
		<div style="flex: 1;">
			    <div style="height: 200px;">
					<el-button style="margin: 20px 0 0 30px;" type="primary" v-print="'#printTest'"  @click="addPrintNum()">{{$t('other.a342')}}</el-button>
					<!-- <el-button id="pprint" style="margin: 20px 0 0 30px;" type="primary" @click="getWaterPiuture()">{{$t('other.a930')}}</el-button> -->
					<!-- <button @click="start_print">开始打印</button> v-print="'#printTest'" -->
				</div>
				<div style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a346')}}</div>
					 <el-select style="margin-left: 15px;" size="mini" v-model="value" :placeholder="$t('other.a50')" @change="chosePage()">
						<el-option
						  v-for="item in options"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					 </el-select>
				</div>
				<div v-show="value == '10' "  style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a347')}}</div>
					<el-input style="width:120px;padding-left:15px" @keyup.native="oop" size="mini" v-model="widthValue" :placeholder="$t('other.a319')"></el-input>
					<label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
				</div>
				<div v-show="value == '10' "  style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a348')}}</div>
					<el-input style="width:120px;padding-left:15px" @keyup.native="oop1" size="mini" v-model="heightValue" :placeholder="$t('other.a319')"></el-input>
					<label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
				</div>

				<!-- <div >
					<div style="font-size: 14px;padding:0 0 10px 10px;">{{$t('other.a931')}}:</div>
					<div class="methods">
						<el-radio v-model="radio" label="1">{{$t('other.a932')}}</el-radio>
						<el-radio v-model="radio" label="2">{{$t('other.a933')}}</el-radio>
						<el-radio v-model="radio" label="3">{{$t('other.a933')}}</el-radio>
					</div>
				</div> -->
			
		</div>
		
	</div>
	
</template>
<script>
import utils from '../../../../utils/utils'
import printApi from '../../../../api/moudles/print.js'
import api from '../../../../api/api'
import newOrderApi from '../../../../api/moudles/newOrders'
import sellerPurchaseApi from '../../../../api/moudles/sellerpurchase'

import orderApi from '../../../../api/moudles/order'
import loading from '../../../../components/loading_2.vue'
import { mapState, mapMutations,  mapActions, } from 'vuex'
import pdf from 'vue-pdf'

	export default {
	    data() {
	      return {
			userId:JSON.parse(localStorage.getItem('userInfo')).userId,
	        th_printdata:[],
			radio:"1",
			barcodeValue:123,
			orderList:[],
			storeItemList:[],
			tip:this.$t('other.a500'),
			arr:[],
			options: [{
				value: 1,
				label: this.$t('other.a493')
			}, {
				value: 2,
				label: this.$t('other.a494')
			}, {
				value: 3,
				label: this.$t("other.a350")
			}, {
				value: 4,
				label: this.$t("other.a351")
			}],
			value:3,
			sliderStyle:{
				'width':'98mm',
				'height':'148mm',
				'background-color': '#fff',
				'margin-top':'10px',
				'position':'relative',
				"page-break-after":"always",
				
			},

			sliderStyleCopy:{
				'width':'98mm',
				'min-height':'130mm',
				'background-color': '#fff',
				'margin-top':'10px',
				'position':'relative',
				"page-break-after":"always",
				
			},
			widthValue:'100mm',
			heightValue:'150mm',
			checked:false,
			options: [{
				value: '10',
				label: this.$t("other.a350")
			}, {
				value: '20',
				label: 'A4'
			}, {
				value: '30',
				label: 'A5'
			}, ],
			value: '10',
			loadingList:[],
			loadedList:[],
			currentPage2: 1,
			pageSize:10,
			chooseList:null,
			generateOrderId:[]
					
		  }
	    },
		components:{
			loading,
			pdf,	
		},
		computed:{
			...mapState({
				picklist: state => state.order.picklist,
				seller: state => state.login.userInfo.userId,
				buttonMapList: state => state.print.buttonMapList,
				toPrintOrders: state => state.common.toPrintOrders,
			}),

			
			
			listCopy(){
				let list=this.th_printdata
				let list2=list
				let list3=[]
				if(this.radio == '1'){
					list3=list2
				}else if(this.radio == '2'){
					list3=list2.filter(p => {
						if(p.genre == 'order'){
							return p
						}
					})
				}else if(this.radio == '3') {
					list3=list2.filter(p => {
						if(p.genre == 'picklist'){
							return p
						}
					})
				}
				console.log('list3',list3)
			
				this.chooseList=list3
				return list3
			},

			
		
			
		},
		watch:{
		
			storeItemList(){
				let list=this.orderList
				let storeItem=this.storeItemList
		
				list.forEach(p => {
					p.items.forEach(i => {
						i.storeItem=storeItem[i.itemId+'_' +i.variationId]
					})
				})
				console.log('list',list)
				this.th_printdata=list
				
			},
			radio(){
				let ttp =this.radio
				console.log('ttp',ttp)
			},
		},
		created(){
	        // this.src=pdf.createLoadingTask(this.src)
			this.getOrdersByOrderId()
			
		},
	
		methods:{
			...mapActions('order', [
				'getUnprocessOrder',//获取所有商店待处理订单
				'auditOrder',
				'getPrintOrder', //打印订单
				'getOrdersBytrickNo'
				
			]),
			...mapActions('print', [
				'addPrintNum',
			
			]),
			...mapMutations('print', [
				'SET_ITEMS',
				'SET_HAS_PRINTED',
				'SET_TTP',
				'SET_HAS_PRINTED_READY',
				'INIT_DATA',
				'FAST_PRINT',
				'UPDATA_PAGE',
				'SENT_PPT'
			]),

            getBarcode(list){
                return new Promise((resolove) => {

                    sellerPurchaseApi
                    .printBarCode(list)
                    .then(res => {
                        resolove(res)
                    })
                })
			},

			getWaterPiuture(){
				
				
					let that=this
					var canvas = document.createElement("canvas");
					canvas.width=800
					canvas.height=800
					let ctx=canvas.getContext('2d')
					let homeImg=this.listCopy[0].orderPdf.image
					let picImg=new Image()
					picImg.setAttribute('crossOrigin', 'anonymous');
					picImg.src=homeImg
					
					picImg.onload = function() {
						ctx.drawImage(picImg,0,0,'100mm','150mm');
						let base64=canvas.toDataURL('image/png')
						console.log('base64',base64)

						// let image=new Image()
						// image.src=waterImg
						// image.setAttribute('crossOrigin', 'anonymous');
						// image.onload = function() {
						// 	ctx.drawImage(image,0,0,800,800);
						// 	let base64=canvas.toDataURL('image/png')
							
							
						
						// }  
					}


			
				
			},
			getOrdersByOrderId(){

				//获取订单审核仓库的地址信息

				let storeAddress=JSON.parse(localStorage.getItem('userInfo')).stores

				

				let listCopy=JSON.parse(localStorage.getItem('unprocessedOrderIds'))
				let barcodelist=listCopy.map(p => {
					return {
						content:p,
						width:80,
						height:50,
					}
				})
				this.getBarcode(barcodelist).then(res => {
					console.log('jnkdsf',res)
					if(res.code == 200){
						let barcodeList=res.data.codes
						newOrderApi
						.getOrderPDF(listCopy)
						.then(res => {
							if(res.code === 200) {
								res.data.forEach((p ,index) => {
									let ttp=barcodeList.find(item => item.content == p.orderId)
									let stores=storeAddress.find(item => item.storeId == p.items[0].storeItem.storeId)
									p.barcode=ttp ? ttp.image : null
									p.createTime=utils.getCurrnetTime(p.createTime)
									p.storeAddress=stores ? stores.address : null 
								})
								this.th_printdata=res.data
								console.log('获取到订单数据',this.th_printdata)
								
								
							}
						})
					}
				})
				

                
				
				
			},
			init(){
				
				this.arr=JSON.parse(JSON.stringify(this.th_printdata))
				console.log('arr',this.arr)
				
				this.arr.forEach(p => {
				
				  let list3=[]
					p.itemsCopy=[]
					if(p.items.length > 0){
						p.items.forEach(k => {
							if(!k.storeItem || !k.storeItem.children  ||  k.storeItem.component){//判断items里的每个item是不是套餐，不是才push
								
								k.cusCode=k.storeItem ? k.storeItem.cusCode : this.$t("other.a354")
								k.skuName=k.storeItem ? k.storeItem.skuName : this.$t("other.a354")
								k.address=k.storeItem ? k.storeItem.address : this.$t("other.a354")
								k.purchaseNum=k.variationQuantityPurchased
								k.rate=1
								p.itemsCopy.push([k])
								k.isComponent=true
						    }
							
							if(k.storeItem && k.storeItem.additions !== null){
								if(k.storeItem.additions.length> 0){
									let arr2=[]
									k.storeItem.additions.forEach(p => {
										p.purchaseNum=k.variationQuantityPurchased
										arr2.push(p)
									})

									list3.push(arr2)
								}
							}

						
							if(k.storeItem && k.storeItem !== null && k.storeItem.children){
								if(k.storeItem.children.length>0 && !k.storeItem.component){
									k.isComponent=false
									let list2=[]
									k.storeItem.children.forEach(i => {
										i.purchaseNum=k.variationQuantityPurchased
									
										list2.push(i)
									})
									list3.push(list2)
									
								}
							}
						})
					}
					if(list3.length){
						list3.forEach(i => {
							p.itemsCopy.push(i)
						})
					}	
				})
				console.log('arr2',this.arr)
				this.th_printdata.forEach(p =>{
					p.genre='order'
				})
				
				
				this.arr.forEach(p => {
					p.genre='picklist'
				})
			
				this.th_printdata=[...this.th_printdata,...this.arr]
				this.th_printdata.sort((a,b) => {return a.No-b.No })
				
				console.log('852',this.th_printdata)
				
				
				
				
			},
		

			addPrintNum(){
				let list=JSON.parse(localStorage.getItem('unprocessedOrderIds'))
				newOrderApi
				.addPrintNum(list)
				.then(res => {
					if(res.code === 200){
						console.log('增加了打印次数！')
					}else{
						console.log('增加了打印次数！',res.msg)
					}
				})


				let obj={
					userId:this.userId,
					orderIds:list.join(),
					createTime:null,
					printType:'3',
				}

				this.insterPrintRecode(obj)
				
			},

			insterPrintRecode(obj){
				newOrderApi
				.insertPrintHistory(obj)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				}else{
				this.$message.warning(res.msg)
				}
				})
			},
			
			 start_print(){
			        this.$print(this.$refs.dfbfjj);//$refs的值要和html里的ref一致
			    },
			
			
			handleSizeChange(val) {
			        console.log(`每页 ${val} 条`);
					this.pageSize=parseInt(`${val}`)
			      },
			handleCurrentChange(val) {
				
				this.currentPage2=parseInt(`${val}`)
				console.log(this.chooseList);
				this.getPirntPdf()
				
				
			},
			//开启分批打印时，触发面单再次请求
			getPirntPdf(){
				setTimeout(() => {
					console.log(this.chooseList)
					let arr=this.chooseList.map(p => {
						return p.logisticInfo && p.trackingNo === ''?  JSON.parse(p.logisticInfo.info_needed.methods) : null
					})
					arr=utils.unique(arr)
					arr[0] === null ? arr.splice(0,1) : arr[0]
					
					this.generateOrderId=arr.map(p => {
						if(p !== null) {
							return p.orderId
						}
					})
					
					console.log(arr)
					console.log(this.generateOrderId)
					if(this.generateOrderId.length){
						console.log(8888)
						printApi
						.startReadyOrders(arr)
						.then(res => {
							if(res.code === 200) {
								console.log('发送订单请求',res.data)
								this.getNewOrderList(this.generateOrderId)
							}
						})
					}
				
				},1000)
			},
			
			//获取最新的面单
			getNewOrderList(arr){
				printApi
				.getNewOrders(arr)
				.then(res => {
					if(res.code === 200){
						console.log('获取到最新的订单',res.data)
						let newData=res.data
						newData.forEach(p => {
							this.th_printdata.forEach(i => {
								if(i.orderId == p.orderId && p.image !== null && p.ready == true){
									i.image=p.image
								}
							})
							this.generateOrderId.forEach((k,index) => {
								if(k === p.orderId && p.ready == true && p.image!== null){
									this.generateOrderId.splice(index,1)
								}
							})
						})
						
						if(this.generateOrderId.length> 0){
							this.getNewOrderList(this.generateOrderId)
						}
					}
				})
			},
			
			chosePage(){
				console.log(this.value)
				if(this.value == '20'){
					this.sliderStyle.width='210mm'
					this.sliderStyle.height='297mm'
				}else if(this.value == '30'){
					this.sliderStyle.width='148mm'
					this.sliderStyle.height='210mm'
				}else if(this.value == '10'){
					this.sliderStyle.width='100mm'
					this.sliderStyle.height='150mm'
					this.widthValue='100'
					this.heightValue='150'
				}
			},

			refreshOrder(item){
				console.log(item)
				printApi
				.startReadyOrders({
					userId:this.userId,
					type:0,
					orderId:item.orderId
				})
				.then(res => {
					if(res.code === 200) {
						console.log('重新加载面单',res.msg)
					}else{
						this.$message.warning(res.msg)
					}
				})
			},
			
			oop1(){
				
				this.sliderStyle.height=this.heightValue + 'mm'
			},
			oop(){
				console.log(this.widthValue)
				this.sliderStyle.width=this.widthValue + 'mm'
			},
			//深拷贝数组
			copy (obj) {
			        var newobj = []
			        if(typeof obj !== 'object'){
			            return;
			        }
			        for(var i in obj){
			           newobj[i] = typeof obj[i] === 'object' ? this.copy(obj[i]) : obj[i];
			        }
			        return newobj
			},
			//从storage上拿下将要打印的item
			
			
		
			
		     ttp(){
				var headstr = "<html><head><title></title></head><body>";
				var footstr = "</body>";
				var newstr = this.$refs.menuItem.innerHTML;
				const oldstr = document.body.innerHTML;
				document.body.innerHTML = headstr+newstr+footstr;
				setTimeout(() => {
					document.body.innerHTML = oldstr;
				},1000)
				window.print(); 
				return false
			
			
			},
		
			
			
			getTiem(time) {
				
				if(typeof(time) ==Array ){
					return 'pending update'
				}else{
					
					return utils.renderTime(time)
				}
				
				
			},
		}
	  }
</script>

<style>



	
	.newpage{
		width: 100%;
		background: #fff;
		z-index: 99999;
		display: flex;
		position: absolute;
		/* display: flex;
		flex-direction: column;
		justify-content: center; */
	
	}

    .newpage .nemgd{
       
        font-size: 18px;
        font-weight: bold;
    }

    .newpage .omtbk{
        border-top: 1px dashed #000;
		 border-bottom: 1px dashed #000;
		padding-top: 3px;
    }

    .newpage .addressWrapper{
        height: 63px;
        /* border: 1px solid #000; */
        padding: 5px 0;
    }

    .newpage .frome{
        font-size: 18px;
		font-weight: bold;

    }

    .newpage .okngjkg{
        box-sizing: border-box;
        padding: 10px 15px;
    }

    .newpage .descTpp{
        font-size: 14px;
    }

    .newpage .ttpkgn{
        display: flex;
        justify-content: space-between;
    }

	.newpage  .el-radio{
		margin-bottom: 8px;
	}

	.newpage .methods{
		display: flex;
		justify-content:flex-start;
		flex-wrap: wrap;
		padding-left: 15px;
	}

	.newpage .item_order_desc{
		padding-right:3px;

	}
	
	
	@page
	{ 
		margin: 0mm 0mm 0mm 0mm;  
	}
	@page:first
	{ 
		margin-top: -5mm ;  
	}
	
	
	.pic-box{
	  width: 100%;
	  image-rendering:-moz-crisp-edges;
	  image-rendering:-o-crisp-edges;
	  image-rendering:-webkit-optimize-contrast;
	  image-rendering: crisp-edges;
	  -ms-interpolation-mode:nearest-neighbor;
	 }
	
	.newpage .pick-list-wrpper{
		width: 100%;
		
		font-size: 12px;
		position: relative;
	}
	
	.orderpage-btn{
		width: 800px;
		margin: 0 auto;
		display: flex;
		justify-content: flex-end;
		padding: 10px 0;
	}
	
	.newpage .print-area{
		
		
		margin-bottom: 200px;
		
		
	}
	.desc-info{
		width: 798px;
		
		border: 2px #000000 solid;
	}

	.newpage .loading-box{
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		margin: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	
	.newpage .orderpage-poo-box{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 5px;
		border-bottom: 2px #000000 dashed
	}

	.newpage .desc_failed{
		padding: 8px 0;
		text-align: center;
		color: rgb(152 148 148)
	}
	
	.newpage  .orderpage-poo{
		min-width: 265px;
		height: 40px;
		border: 2px solid #000000;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		margin: 5px 10px;
	}
	
	.newpage  .receipt-item{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding:5px 10px;
	}
	
	.newpage  .receipt-item .area {
		display: inline-block;
		width: 50%;
		font-size: 18px;
	}
	
	.newpage  .desc-info-left-text{
		font-size: 18px;
		font-weight: bold;
		padding-right: 30px;
	}

	.newpage .phone{
		padding-top: 5px ;
	}
	
	.newpage  .desc-info-footer{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 5px 10px;
	}
	
	.newpage  .tto{
		display: inline-block;
		width: 200px;
		text-align: center;
		box-sizing: border-box;
		padding: 5px;
	}
	.newpage  .tto01{
		display: inline-block;
		width: 100px;
	}
	.newpage  .cco{
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		border-bottom: 1px #000000 solid;
		box-sizing: border-box;
		padding: 0 10px;
	}
	
	.newpage  .city-tap{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 0;
		padding: 5px 15px;
		font-size: 18px;
	}

	.gigln{
		display: flex;
		justify-content: space-between;
		border-top: 1px dashed #000;
		padding: 5px;
	}

	.giglnCopy{
		display: flex;
		justify-content: space-between;
		border-bottom: 1px dashed #000;
		
	}


	
	.newpage  .city-tap01{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 5px;
		font-size: 18px;
		padding: 5px 15px;
	}


	
	
	
	
	.newpage  .desc{
		/* position: absolute;
		top: 40%;
		left: 25%;
		bottom: 0;
		right: 0;
		margin: auto; */
		font-size: 18px;
		font-weight: bold;
		color: red;
		opacity: 0.3;
		
		
		
	}
	.newpage  .oook{
		margin-bottom: 20px;
		
	}
	

	
/* 	.pp-wrapper{
		position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto;
	}	 */
	
	.newpage  .printTest-box{
		width: 80%;
		overflow-y: auto;
		height: 100vh;
		background-color: #000;
		position: relative;
	
	}
	
	.newpage  .page-box{
		/* width: 800px;
		height: 670px; */
		overflow: hidden;
		background-color: #fff;
		/* position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto; */
		
	}
	
	.newpage .el-icon-loading:before {
	    content: "\E6CF";
	    font-size: 60px;
	}

	.newpage .loading_style{
		background-color: #454040;
		position: absolute !important;
		width: 100%;
		height: 100vh;
		left: 0;
		
	}


	
	.el-popper{
		z-index: 999999!important;
	}
	
	.img-wrapper{
	  width: 1100px;
	  height: 1188px;
	  margin: -369.5px -354.5px;
	  transform: scale(0.36);
	}
	
	.fenpi{
		display: flex;
		align-items: center;
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #fff;
		position: fixed;
		bottom: 0;
		z-index: 999999;
		font-size: 14px;
		padding-left: 15px;
	}
	
	.fenpi-item{
		margin-right: 10px;
	}
	
	
	
</style>
